<template>
  <div class="homePage">
    <img class="bg5" src="@/assets/image/module/bg5.png" alt="" />

    <div class="title-box">{{ $t("module.activity.title1") }}</div>
    <div class="card-box">
      <div class="card-item" v-for="(item, index) in list1" :key="index">
        <div class="img">
          <img :src="item.thumbImageUrl" @error="handleError" />
        </div>
        <div class="right">
          <div class="title">{{ item.title }}</div>
          <div class="date">
            {{ item.startDate | dateFrom }} —— {{ item.endDate | dateFrom }}
          </div>
          <div class="content">
            {{ item.summary }}
          </div>
          <div class="bottom">
            <div class="glod">
              {{ $t("module.activity.title2") }}:
              <span
                >{{ item.minPoints }}-{{ item.maxPoints
                }}{{ $t("module.activity.title3") }}</span
              >
            </div>
            <button class="glod-but" @click="goUrl(item.url)">
              {{ $t("module.activity.title4") }}
            </button>
          </div>
        </div>
      </div>
      <div class="empty-box" v-if="list1.length === 0">
        <el-empty :description="$t('common.message.noData')"></el-empty>
      </div>
    </div>
    <div class="title-box title-box2">{{ $t("module.activity.title5") }}</div>

    <div class="card-box card-opacity">
      <div class="card-item" v-for="(item, index) in list2" :key="index">
        <div class="img">
          <img :src="item.thumbImageUrl" @error="handleError" />
        </div>
        <div class="right">
          <div class="title">{{ item.title }}</div>
          <div class="date">
            {{ item.startDate | dateFrom }} —— {{ item.endDate | dateFrom }}
          </div>
          <div class="content">
            {{ item.summary }}
          </div>
          <div class="bottom">
            <div class="glod">
              {{ $t("module.activity.title2") }}:
              <span
                >{{ item.minPoints }}-{{ item.maxPoints
                }}{{ $t("module.activity.title3") }}</span
              >
            </div>
            <button>{{ $t("module.activity.title4") }}</button>
          </div>
        </div>
      </div>

      <div class="empty-box" v-if="list2.length === 0">
        <el-empty :description="$t('common.message.noData')"></el-empty>
      </div>
    </div>
  </div>
</template>
<script>
import { getActivities } from "@/api/user";
export default {
  filters: {
    dateFrom(dateStr) {
      const date = new Date(dateStr);
      // 2. 转换为 ISO 字符串 (如 "2025-04-14T00:00:00.000Z") 并截取前10位
      const result = date.toISOString().split("T")[0];
      return result;
    },
  },
  data() {
    return {
      list1: [],
      list2: [],
    };
  },

  methods: {
    goUrl(url) {
      window.open(url, "_blank");
    },
    handleError(e) {
      console.log("触发");
      e.target.src = require('@/assets/image/common.png');
      e.target.onerror = null; // 防止闪图/死循环
    },
  },
  created() {
    getActivities().then((res) => {
      if (res.code === 200) {
        res.data.list.forEach((element) => {
          if (element.status === 1) {
            this.list1.push(element);
          } else {
            this.list2.push(element);
          }
        });
      }
      console.log("list1", this.list1);
    });
  },
  mounted() {},
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.homePage {
  .bg5 {
    width: 100%;
    height: auto;
  }

  .title-box {
    font-size: 22px;
    color: #474f66;
    font-weight: bolder;
    margin: 26px 0 0 140px;
  }
  .card-box {
    width: 100%;
    box-sizing: border-box;
    padding: 0 140px;
    display: flex;
    flex-wrap: wrap;
    .card-item {
      width: calc((100% - 16px) / 2);
      margin-right: 16px;
      min-height: 213px;
      background-color: #ffffff;
      box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.05);
      border-radius: 8px;
      padding: 16px;
      box-sizing: border-box;
      margin-top: 16px;
      display: flex;
      .img {
        width: 196px;
        height: 100%;
        // background: #efefef;
        border-radius: 8px;
        flex-shrink: 0;
        margin-right: 33px;
        display: flex;
        justify-content: center;
        align-content: center;
        img {
          width: 100%;
          height: auto;
        }
      }
      .right {
        color: #474f66;
        width: 100%;
        .title {
          font-size: 16px;
        }
        .date {
          font-size: 14px;
          margin-top: 10px;
        }
        .content {
          min-height: 66px;
          font-size: 14px;
          margin-top: 10px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3; /* 显示的行数，可以根据需要修改 */
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 22px;
        }
        .bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 20px;
          .glod {
            font-size: 14px;
            span {
              color: #ef4000;
            }
          }
          .glod-but {
            cursor: pointer;
          }
          button {
            padding: 0;
            border: none;
            width: 104px;
            height: 32px;
            line-height: 32px;
            background: linear-gradient(141deg, #a896ff 0%, #8b4eff 100%);
            border-radius: 16px;
            color: #fff;
            font-size: 14px;
          }
        }
      }
    }
    .card-item:nth-child(2n) {
      margin-right: 0;
    }
  }
  .card-opacity {
    margin-bottom: 30px;
    .card-item {
      opacity: 0.5;
    }
  }
}
.empty-box {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-right: 0 !important;
  .el-empty {
    margin-right: 0 !important;
  }
}
</style>
<style lang="scss" scoped>
@media only screen and (max-width: 1300px) {
  .homePage {
    .title-box {
      margin-left: 70px;
    }
    .card-box {
      padding: 0 70px;
    }
  }
}

@media only screen and (max-width: 1200px) {
  .homePage {
    .title-box {
      margin-left: 30px;
    }
    .card-box {
      padding: 0 30px;
      .card-item {
        .right {
          .bottom {
            button {
              flex-shrink: 0;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1000px) {
  .homePage {
    .bg5 {
      width: calc(100% - 30px);
      margin-left: 15px;
      border-radius: 8px;
      margin-top: 8px;
    }
    .title-box {
      margin-left: 15px;
      margin-top: 18px;
      font-size: 22px;
      color: #232323;
    }
    // .title-box2 {
    //   display: none;
    // }
    // .card-opacity {
    //   display: none;
    // }
    .card-box {
      padding: 0 15px;
      margin-bottom: 30px;
      .card-item {
        width: 100%;
        margin-right: 0 !important;
        margin-top: 15px;
        .img {
          min-width: 100px;
        }
      }
    }
  }
}

@media only screen and (max-width: 700px) {
  .homePage {
    .fiex {
      display: none;
    }
    .right {
      .task-list {
        .task-item {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }
  }
}

@media only screen and (max-width: 500px) {
  .homePage {
    .fiex {
      display: none;
    }
    .right {
      .task-list {
        .task-item {
          width: 100%;
          margin-right: 0 !important;
        }
      }
      .bottom {
        flex-direction: column;
        align-items: flex-start !important;
        justify-content: flex-start !important;
        .glod {
          margin-bottom: 10px;
        }
      }
    }

    .card-box {
      padding: 0 15px;
      margin-bottom: 30px;
      .card-item {
        width: 100%;
        margin-right: 0 !important;
        margin-top: 15px;
        .img {
          min-width: 150px;
          max-width: 150px;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>